export default "/fonts/vendor/katex/dist/KaTeX_Main-Italic.woff?fd947498bc16392e76c23adf58513fb3";